import React, { useContext, useEffect, useState } from "react";
import { Form } from "react-router-dom";
import Application from "../../../StateContext/Application";
import { usePDF } from "react-to-pdf";
import { CSVLink } from "react-csv";
import {
  Excel11,
  failed,
  PDF11,
  pending,
  success,
  Winnericon32,
} from "../../../../../public/LoginImages/importimages";
import { apiurl } from "../../../../../path";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import iconSrc from "../../../../../public/LoginImages/Dashboard32.png";
import SearchIcon from "../../../../../public/LoginImages/Search32.png";
import { useLanguage } from "../../../../../lang/langcontext/LanguageContext";
import { FaSearch } from "react-icons/fa";
import { formatDateTime, formatDate } from "../../../../../utils/DateFormat";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const ECSReport = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const statecalls = useContext(Application);
  const {
    FetchECSFiles,
    FetchECSReport,
    FetchECSDashboardReport,
    FetchDistrictFilter,
    Usermenu,
  } = statecalls;
  const [fileName, SetFileName] = useState([]);
  const [ecsdata, SetECSData] = useState([]);
  const [ecsdashboarddata, SetECSDashboardData] = useState({
    totalGenerated: { count: 0, amount: 0 },
    awaited: { count: 0, amount: 0 },
    completed: { count: 0, amount: 0 },
    return: { count: 0, amount: 0 },
    failed: { count: 0, amount: 0 },
  });
  const [districtData, setDistrictData] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [selectedDivision, setSelectedDivision] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [allFiles, setAllFiles] = useState([]);
  const [searchFileData, SetSearchFileData] = useState("");
  const { targetRef } = usePDF({ filename: "ECS Report.pdf" });
  const [CSVDATA, SetCSVDATA] = useState([]);
  const [summary, setSummary] = useState({
    file: "",
    count: 0,
    amount: 0,
    mahapaystatus: "",
  });

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(ecsdata.length / itemsPerPage);
  const paginatedData = ecsdata.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  const [renderdata, SetRenderdata] = useState([]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  useEffect(() => {
    GetDistricts();
    GetAuctions();
    GetUsername();
  }, []);

  useEffect(() => {
    if (!selectedDistrict) {
      // All districts selected
      SetFileName(allFiles);
      return;
    }
    const filtered = allFiles.filter((file) => {
      const itemDistrict = file?.target_district || "";

      return (
        itemDistrict.toLowerCase() === selectedDistrict.toLowerCase() ||
        itemDistrict
          .toLowerCase()
          .startsWith(`${selectedDistrict.toLowerCase()}-`)
      );
    });
    SetFileName(filtered);
    SetSearchFileData("");
  }, [selectedDistrict, allFiles]);

  async function GetUsername() {
    const data = await Usermenu();
    SetRenderdata(await data);
  }

  async function GetAuctions() {
    try {
      let data = await FetchECSFiles();
      console.log(data);
      SetFileName(data);
      setAllFiles(data);
    } catch (error) {
      console.log(error);
    }
  }

  async function GetDistricts() {
    try {
      const data = await FetchDistrictFilter();
      setDistrictData(data);
      // Unique divisions
      const divisions = [
        ...new Map(data.map((item) => [item.Region_Marathi, item])).values(),
      ];

      setDivisionList(divisions);

      // Unique main districts
      const districts = [
        ...new Set(
          data
            .map((item) =>
              item?.District_Marathi?.split("-")[0]?.trim()
            )
            .filter(Boolean)
        ),
      ];

      setDistrictList(districts);
    } catch (err) {
      console.log(err);
    }
  }

  const handleDivisionChange = (division) => {
    setSelectedDivision(division);
    setSelectedDistrict("");

    const filtered = districtData.filter(
      (item) =>
        item.Region_Marathi === division &&
        item.District_Marathi &&
        item.District_Marathi.trim() !== "",
    );

    // ✅ Unique main district names
    const uniqueDistricts = [
      ...new Set(
        filtered
          .map((item) =>
            item?.District_Marathi?.split("-")[0]?.trim()
          )
          .filter(Boolean)
      ),
    ];

    setDistrictList(uniqueDistricts);
  };

  async function GetAllDashboardReport() {
    try {
      const data = await FetchECSDashboardReport();
      if (data && data.length > 0) {
        const totalGeneratedCount = data.length;
        const totalGeneratedAmount = data.reduce(
          (sum, d) => sum + Number(d.refund_amount || 0),
          0,
        );
        const awaitedData = data.filter((d) => d.status === "Pending");
        const completedData = data.filter(
          (d) => d.status === "Successful/Paid",
        );
        const returnData = data.filter((d) => d.status === "Return");
        const failedData = data.filter(
          (d) =>
            d.status !== "Pending" &&
            d.status !== "Successful/Paid" &&
            d.status !== "Return",
        );

        SetECSDashboardData({
          totalGenerated: {
            count: totalGeneratedCount,
            amount: totalGeneratedAmount,
          },
          awaited: {
            count: awaitedData.length,
            amount: awaitedData.reduce(
              (sum, d) => sum + Number(d.refund_amount || 0),
              0,
            ),
          },
          completed: {
            count: completedData.length,
            amount: completedData.reduce(
              (sum, d) => sum + Number(d.refund_amount || 0),
              0,
            ),
          },
          return: {
            count: returnData.length,
            amount: returnData.reduce(
              (sum, d) => sum + Number(d.refund_amount || 0),
              0,
            ),
          },
          failed: {
            count: failedData.length,
            amount: failedData.reduce(
              (sum, d) => sum + Number(d.refund_amount || 0),
              0,
            ),
          },
        });
      }
    } catch (err) {
      console.error("Dashboard fetch error", err);
    }
  }

  // Prepare chart data
  const chartData = [
    { name: t("Generated"), Count: ecsdashboarddata.totalGenerated.count },
    { name: t("Awaited"), Count: ecsdashboarddata.awaited.count },
    { name: t("Completed"), Count: ecsdashboarddata.completed.count },
    { name: t("Return"), Count: ecsdashboarddata.return.count },
    { name: t("Failed"), Count: ecsdashboarddata.failed.count },
  ];

  useEffect(() => {
    GetAllDashboardReport();
  }, []);

  async function GetECSReport() {
    try {
      if (!searchFileData) {
        alert("Please Select File Name");
      } else {
        let data = await FetchECSReport(searchFileData);
        SetECSData(data);

        const selectedFile = fileName.find(
          (item) => item.FileName === searchFileData,
        );

        if (data && data.length > 0) {
          const totalAmount = data.reduce(
            (sum, item) => sum + Number(item.refund_amount || 0),
            0,
          );
          setSummary({
            file: searchFileData,
            count: data.length,
            amount: totalAmount,
            mahapaystatus: selectedFile?.mahapaystatus || "-",
          });
        } else {
          setSummary({
            file: searchFileData,
            count: 0,
            amount: 0,
            mahapaystatus: selectedFile?.mahapaystatus || "-",
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  function onSavefile() {
    if (ecsdata.length > 0) {
      const headers = Object.keys(ecsdata[0]);
      const csvData = ecsdata.map((item) => headers.map((key) => item[key]));
      const finalcsv = [headers, ...csvData];
      SetCSVDATA(finalcsv);
    }
  }

  const formatINR = (val) => {
    if (val === "" || val === null || val === undefined) return "";
    const number = Number(val);
    if (isNaN(number)) return "";
    return new Intl.NumberFormat("en-IN", { maximumFractionDigits: 2 }).format(
      number,
    );
  };



const toPDF = () => {
  if (!Array.isArray(ecsdata) || ecsdata.length === 0) {
    alert("No data available to download.");
    return;
  }

  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a4",
  });

  const headers = [
    "Sr.No.",
    "Unique_ID",
    "Account_HolderName",
    "Account Number",
    "IFSC Code",
    "Branch Name",
    "Bank Name",
    "Amount",
    "Payment Mode",
    "Status",
    "Description",
    "Date",
    "UTR No",
    "Payment Date",
  ];

  // Export every row; serial numbers always start at 1.
  const rows = ecsdata.map((item, index) => [
    index + 1,
    item.Unique_ID ?? "--",
    item.Account_HolderName ?? "--",
    item.AccNumber ?? "--",
    item.IFSC_CODE ?? "--",
    item.BranchName ?? "--",
    item.BankName ?? "--",
    item.refund_amount ?? "--",
    item.Payment_Mode ?? "--",
    item.status ?? "--",
    item.statusDesc ?? "--",
    item.Date ? formatDateTime(item.Date) : "--",
    item.utr_no ?? "--",
    item.Payment_Date
      ? formatDateTime(item.Payment_Date)
      : "--",
  ]);

  // Report title and summary
  doc.setFontSize(16);
  doc.text("ECS Report", 8, 12);

  doc.setFontSize(9);
  doc.text(`File Name: ${summary.file || "--"}`, 8, 19);
  doc.text(`Total Count: ${ecsdata.length}`, 8, 25);

  const totalAmount = ecsdata.reduce(
    (sum, item) => sum + Number(item.refund_amount || 0),
    0
  );

  doc.text(
    `Total Amount: Rs. ${formatINR(totalAmount)}`,
    8,
    31
  );

  doc.text(
    `File Status: ${summary.mahapaystatus || "--"}`,
    8,
    37
  );

  autoTable(doc, {
    head: [headers],
    body: rows,
    startY: 43,

    // Fill the available horizontal space, not the page height.
    tableWidth: "auto",
    margin: {
      left: 8,
      right: 8,
      top: 8,
      bottom: 12,
    },

    theme: "grid",
    showHead: "everyPage",

    styles: {
      font: "helvetica",
      fontSize: 7,
      cellPadding: 2,
      overflow: "linebreak",
      valign: "middle",
      lineWidth: 0.15,
      lineColor: [180, 180, 180],
    },

    headStyles: {
      fillColor: [35, 112, 160],
      textColor: [255, 255, 255],
      fontSize: 7,
      fontStyle: "bold",
      halign: "center",
      valign: "middle",
    },

    // Let autoTable distribute widths within the available page width.
    columnStyles: {
      0: { cellWidth: 12 },
      7: { cellWidth: 16 },
    },

    horizontalPageBreak: false,

    didDrawPage: (data) => {
      const pageHeight = doc.internal.pageSize.getHeight();
      const pageWidth = doc.internal.pageSize.getWidth();

      doc.setFontSize(8);
      doc.text(
        `Page ${data.pageNumber}`,
        pageWidth - 8,
        pageHeight - 5,
        { align: "right" }
      );
    },
  });

  const safeFileName = (summary.file || "ECS_Report")
    .replace(/[<>:"/\\|?*]/g, "_");

  doc.save(`${safeFileName}.pdf`);
};


  

  return (
    <>
      <div
        style={{
          backgroundColor: "#f4f8fc",
          maxHeight: "90vh",
          overflowY: "auto",
          msOverflowStyle: "none",
          scrollbarWidth: "none",
          padding: "20px",
        }}
        className="no-scrollbar"
      >
        <div className="dashboard-header-name">
          <img
            src={iconSrc}
            alt={"Dashboard Icon"}
            className="dashboard-menu-icon"
          />
          <h1 className="dashboard-title">{t("ECS Report")}</h1>
        </div>
        <div style={{ padding: "20px", backgroundColor: "#f5f9fc" }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
              gap: "20px",
            }}
          >
            {/* Total Generated */}
            <div
              style={{
                background: "linear-gradient(to right, #3d8696, #2370a0)",
                color: "white",
                padding: "20px",
                borderRadius: "12px",
                boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
              }}
            >
              <h4>{t("Total ECS Generated")}</h4>
              <p style={{ fontSize: "24px", fontWeight: "600" }}>
                {" "}
                {ecsdashboarddata.totalGenerated.count}{" "}
              </p>
              <p>₹ {ecsdashboarddata.totalGenerated.amount}</p>
            </div>
            {/* Awaited */}
            <div
              style={{
                background: "linear-gradient(to right, #f7b733, #fc4a1a)",
                color: "white",
                padding: "20px",
                borderRadius: "12px",
                boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
              }}
            >
              <h4>{t("ECS Awaited")}</h4>
              <p style={{ fontSize: "24px", fontWeight: "600" }}>
                {ecsdashboarddata.awaited.count}
              </p>
              <p>₹ {ecsdashboarddata.awaited.amount}</p>
            </div>
            {/* Completed */}
            <div
              style={{
                background: "linear-gradient(to right, #11998e, #38ef7d)",
                color: "white",
                padding: "20px",
                borderRadius: "12px",
                boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
              }}
            >
              <h4>ECS Completed</h4>
              <p style={{ fontSize: "24px", fontWeight: "600" }}>
                {" "}
                {ecsdashboarddata.completed.count}{" "}
              </p>
              <p>₹ {ecsdashboarddata.completed.amount}</p>
            </div>
            {/* Return */}
            <div
              style={{
                background: "linear-gradient(to right, #8185ffff, #31009cff)",
                color: "white",
                padding: "20px",
                borderRadius: "12px",
                boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
              }}
            >
              <h4>{t("ECS Return")}</h4>
              <p style={{ fontSize: "24px", fontWeight: "600" }}>
                {" "}
                {ecsdashboarddata.return.count}
              </p>
              <p>₹ {ecsdashboarddata.return.amount}</p>
            </div>
            {/* Failed */}
            <div
              style={{
                background: "linear-gradient(to right, #e52d27, #b31217)",
                color: "white",
                padding: "20px",
                borderRadius: "12px",
                boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
              }}
            >
              <h4>{t("ECS Failed")}</h4>
              <p style={{ fontSize: "24px", fontWeight: "600" }}>
                {" "}
                {ecsdashboarddata.failed.count}{" "}
              </p>
              <p>₹ {ecsdashboarddata.failed.amount}</p>
            </div>
          </div>
        </div>
        <div style={{ padding: "2rem" }}>
          <div
            style={{
              display: "grid",
              border: "2px solid red",
              borderRadius: "10px",
              border: "none",
              padding: "20px",
              backgroundColor: "white",
            }}
          >
            <div style={{ display: "grid" }}>
              <Form>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    flexWrap: "wrap",
                    gap: "20px",
                    alignItems: "center",
                  }}
                >
                  {renderdata?.Data?.District === "State" && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <label className="form-label mx-3">
                          {t("Division")}
                        </label>
                        <select
                          className="form-control"
                          value={selectedDivision}
                          onChange={(e) => handleDivisionChange(e.target.value)}
                        >
                          <option value="">Select Division</option>
                          {divisionList.map((item) => (
                            <option
                              key={item.Region_Marathi}
                              value={item.Region_Marathi}
                            >
                              {item.Region_Marathi == "Kokan"
                                ? "कोंकण"
                                : item.Region_Marathi}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <label className="form-label mx-3">
                          {t("District")}
                        </label>
                        <select
                          className="form-control"
                          value={selectedDistrict}
                          onChange={(e) => {
                            setSelectedDistrict(e.target.value);
                            SetSearchFileData("");
                          }}
                          style={{ width: "220px" }}
                        >
                          <option value="">Select District</option>
                          {districtList.map((district, index) => (
                            <option
                              key={index}
                              value={district}
                            >
                              {district}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  )}
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <label
                        className="form-label mx-3"
                        style={{ fontWeight: "600" }}
                      >
                        File Name
                      </label>
                      <select
                        className="form-control"
                        value={searchFileData}
                        onChange={(e) => {
                          SetSearchFileData(e.target.value);
                        }}
                        style={{ width: "25rem", fontWeight: "600" }}
                      >
                        <option value="" disabled>
                          {" "}
                          Select File
                        </option>
                        {Array.isArray(fileName) &&
                          fileName.map((e, index) => (
                            <option key={index} value={e.FileName}>
                              {e.FileName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="mx-2">
                      <button
                        className="pending-button"
                        type="button"
                        onClick={() => GetECSReport()}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          border: "2px solid #0071bc",
                          borderRadius: "5px",
                          width: "6rem",
                          height: "2.3rem",
                          fontSize: "14px",
                          color: "#0071bc",
                          backgroundColor: "white",
                          cursor: "pointer",
                        }}
                      >
                        {/* <img src="" className="mx-1" alt="Search" />  */}
                        Search
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
        <div
          style={{
            padding: "20px",
            overflow: "auto",
            backgroundColor: "#f5f9fc",
          }}
        >
          <div
            style={{
              display: "grid",
              borderRadius: "20px",
              padding: "20px",
              backgroundColor: "white",
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <h5 style={{ paddingTop: "10px" }}>{t("Payment Data")}</h5>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "10px",
                  paddingBottom: "10px",
                }}
              >
                {ecsdata.length > 0 ? (
                  <>
                    
                    <CSVLink
                      filename={`ECS_Data_${new Date().toISOString().slice(0, 10)}.csv`}
                      data={CSVDATA}
                      className="btn btn-success"
                      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '10rem', height: '2rem', border: "1px solid #ccc", borderRadius: '5px', gap: '3px', color: 'white', textDecoration: 'none', fontSize: '16px', fontWeight: '500', cursor: 'pointer' }}
                      onClick={onSavefile}
                    >
                      <img src="" style={{ width: "14px" }} />{" "}
                      {t("Download Excel")}
                    </CSVLink>
                    <button
                      onClick={toPDF}
                      type='button' className="btn btn-danger" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '10rem', height: '2rem', border: "1px solid #ccc", borderRadius: '5px', gap: '3px', color: 'white', cursor: 'pointer', fontSize: "16px" }}
                    >
                      <img src="" style={{ width: "14px" }} />{" "}
                      {t("Download PDF")}
                    </button>

                  </>
                ) : (
                  <>
                    <div
                      className="btn btn-success" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '10rem', height: '2rem', border: "1px solid #ccc", borderRadius: '5px', gap: '3px', color: 'white', fontSize: '16px', cursor: 'pointer', padding: "4px 4spx" }} disabled
                    >
                      <img src="" style={{ width: "14px" }} />{" "}
                      {t("Download Excel")}
                    </div>
                    <div
                      type="button"
                      className="btn btn-danger" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '10rem', height: '2rem', border: "1px solid #ccc", borderRadius: '5px', gap: '3px', color: 'white', fontSize: '16px', cursor: 'pointer', padding: "4px 4px" }} disabled><img src="" style={{ width: '16px' }} />
                      <img src="" style={{ width: "14px" }} />{" "}
                      {t("Download PDF")}
                    </div>

                  </>
                )}
              </div>
            </div>
            <div
              className="col-12 tableDesign"
              style={{ overflowX: "auto" }}
              ref={targetRef}
            >
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: "18px",
                }}
              >
                <thead
                  style={{
                    background:
                      "linear-gradient(to Right, #3d8696, #2370a0, #4163a4, #575aa7, #754baa)",
                    backgroundImage: "none",
                  }}
                >
                  <tr
                    style={{
                      color: "white",
                      border: "none",
                      height: "3rem",
                      fontSize: "18px",
                    }}
                  >
                    <th>{t("File Name")}</th>
                    <th>{t("Total Count")}</th>
                    <th>{t("Total Amount")}</th>
                    <th>{t("File Status")}</th>
                  </tr>
                </thead>
                <tbody>
                  {summary.file && (
                    <tr
                      style={{
                        backgroundColor: "#c8e5fc",
                        fontWeight: "600",
                        padding: "8px",
                        fontSize: "18px",
                      }}
                    >
                      <td>{summary.file}</td>
                      <td>{summary.count}</td>
                      <td>{formatINR(summary.amount)}</td>
                      <td>{summary.mahapaystatus}</td>
                    </tr>
                  )}
                </tbody>
              </table>

              {/* ✅ Scrollable Detail Table */}
              <div className="col-12 tableDesign" style={{ overflowX: "auto" }}>
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    overflowX: "auto",
                    fontSize: "18px",
                  }}
                >
                  <thead
                    style={{
                      background:
                        "linear-gradient(to Right, #3d8696, #2370a0, #4163a4, #575aa7, #754baa)",
                      backgroundImage: "none",
                    }}
                  >
                    <tr
                      style={{
                        color: "white",
                        border: "none",
                        height: "3rem",
                        fontSize: "18px",
                      }}
                    >
                      <th style={{ minWidth: "70px" }}>{t("Sr.No.")}</th>
                      <th style={{ minWidth: "70px" }}>{t("Unique_ID")}</th>
                      <th style={{ minWidth: "70px" }}>
                        {t("Account_HolderName")}
                      </th>
                      <th style={{ minWidth: "70px" }}>
                        {" "}
                        {t("Account Number")}
                      </th>
                      <th style={{ minWidth: "70px" }}>{t("IFSC Code")}</th>
                      <th style={{ minWidth: "70px" }}>{t("Branch Name")}</th>
                      <th style={{ minWidth: "70px" }}>{t("Bank Name")}</th>
                      <th style={{ minWidth: "70px" }}>{t("Amount")}</th>
                      <th style={{ minWidth: "70px" }}>{t("Payment Mode")}</th>
                      <th style={{ minWidth: "70px" }}>{t("Status")}</th>
                      <th style={{ minWidth: "70px" }}>{t("Description")}</th>
                      <th style={{ minWidth: "70px" }}>{t("Date")}</th>
                      <th style={{ minWidth: "70px" }}>{t("UTR No")}</th>
                      <th style={{ minWidth: "140px" }}>{t("Payment Date")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedData && paginatedData.length > 0 ? (
                      paginatedData.map((e, index) => (
                        <tr
                          key={index}
                          style={{ background: "white", fontSize: "18px" }}
                        >
                          <td>
                            {(currentPage - 1) * itemsPerPage + index + 1}
                          </td>
                          <td style={{ padding: "8px" }}>{e.Unique_ID}</td>
                          <td style={{ padding: "8px" }}>
                            {" "}
                            {e.Account_HolderName}{" "}
                          </td>
                          <td style={{ padding: "8px" }}>{e.AccNumber}</td>
                          <td style={{ padding: "8px" }}>{e.IFSC_CODE}</td>
                          <td style={{ padding: "8px" }}>{e.BranchName}</td>
                          <td style={{ padding: "8px" }}>{e.BankName}</td>
                          <td style={{ padding: "8px" }}>{e.refund_amount}</td>
                          <td style={{ padding: "8px" }}>{e.Payment_Mode}</td>
                          <td style={{ padding: "8px" }}>{e.status}</td>
                          <td style={{ padding: "8px" }}>{e.statusDesc}</td>
                          <td style={{ padding: "8px" }}>
                            {" "}
                            {e.Date
                              ?
                              formatDateTime(e.Date)
                              : "-"}{" "}
                          </td>
                          <td style={{ padding: "8px" }}>
                            {e.utr_no ? e.utr_no : "-"}
                          </td>
                          <td style={{ padding: "8px" }}>
                            {e.Payment_Date
                              ? formatDateTime(e.Payment_Date)
                              : "-"}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="14"
                          style={{
                            textAlign: "center",
                            background: "white",
                            padding: "8px",
                          }}
                        >
                          {" "}
                          {t("No data available in table")}{" "}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            {/* Pagination */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                height: "3rem",
                alignItems: "center",
                fontSize: "18px",
              }}
            >
              <div>
                <p style={{ margin: "0px" }}>
                  {" "}
                  Showing {paginatedData.length} of {ecsdata.length}{" "}
                  entries{" "}
                </p>
              </div>
              <div>
                {/* First Page Button */}
                <button
                  onClick={() => handlePageChange(1)}
                  disabled={currentPage === 1}
                  style={{
                    backgroundColor: "white",
                    color: "black",
                    border: "1px solid lightgrey",
                    cursor: "pointer",
                    fontSize: "24px",
                    margin: 0,
                    borderRadius: 0,
                  }}
                >
                  {" "}
                  &laquo;{" "}
                </button>
                {/* Previous Button */}
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  style={{
                    backgroundColor: "white",
                    color: "black",
                    border: "1px solid lightgrey",
                    cursor: "pointer",
                    fontSize: "24px",
                    margin: 0,
                    borderRadius: 0,
                    borderLeft: "none",
                  }}
                >
                  {" "}
                  &lt;{" "}
                </button>
                {/* Page Buttons */}
                {Array.from({ length: totalPages }, (_, index) => (
                  <button
                    key={index}
                    onClick={() => handlePageChange(index + 1)}
                    style={{
                      background: "#0B83C3",
                      color: currentPage === index + 1 ? "white" : "black",
                      cursor: "pointer",
                      fontSize: "24px",
                      width: "3rem",
                      margin: 0,
                      borderRadius: 0,
                      border: "1px solid lightgrey",
                      borderLeft: "none",
                    }}
                  >
                    {" "}
                    {index + 1}
                  </button>
                ))}
                {/* Next Button */}
                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  style={{
                    backgroundColor: "white",
                    color: "black",
                    border: "1px solid lightgrey",
                    cursor: "pointer",
                    fontSize: "24px",
                    margin: 0,
                    borderRadius: 0,
                    borderLeft: "none",
                  }}
                >
                  {" "}
                  &gt;{" "}
                </button>
                {/* Last Page Button */}
                <button
                  onClick={() => handlePageChange(totalPages)}
                  disabled={currentPage === totalPages}
                  style={{
                    backgroundColor: "white",
                    color: "black",
                    border: "1px solid lightgrey",
                    cursor: "pointer",
                    fontSize: "24px",
                    margin: 0,
                    borderRadius: 0,
                    borderLeft: "none",
                  }}
                >
                  {" "}
                  &raquo;
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Chart */}
        <div
          className="mx-auto pb-5 mb-5"
          style={{
            width: "97%",
            height: 400,
            backgroundColor: "white",
            padding: "20px",
            borderRadius: "12px",
          }}
        >
          <h3 style={{ textAlign: "center", marginBottom: "20px" }}>
            {" "}
            {t("ECS Status Count")}{" "}
          </h3>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={chartData}
              margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="Count" name={t("Count")} fill="#8884d8" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </>
  );
};

export default ECSReport;

// --> Old Code

// import React, { useContext, useEffect, useState } from 'react'
// import { Form } from 'react-router-dom'
// import Application from "../../../StateContext/Application"
// import { usePDF } from 'react-to-pdf'
// import { CSVLink } from 'react-csv'
// import { Excel11, failed, PDF11, pending, success, Winnericon32 } from '../../../../../public/LoginImages/importimages'
// import { apiurl } from '../../../../../path'
// import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
// import iconSrc from "../../../../../public/LoginImages/Dashboard32.png"
// import { useLanguage } from '../../../../../lang/langcontext/LanguageContext';
// import { FaSearch } from "react-icons/fa";

// const ECSReport = () => {
//     const { language, toggleLanguage, t } = useLanguage();
//     const statecalls = useContext(Application)
//     const { FetchECSFiles, FetchECSReport, FetchECSDashboardReport } = statecalls;
//     const [fileName, SetFileName] = useState('')
//     const [ecsdata, SetECSData] = useState('')
//     const [ecsdashboarddata, SetECSDashboardData] = useState({
//         totalGenerated: { count: 0, amount: 0 },
//         awaited: { count: 0, amount: 0 },
//         completed: { count: 0, amount: 0 },
//         return: { count: 0, amount: 0 },
//         failed: { count: 0, amount: 0 },
//     });

//     const [searchFileData, SetSearchFileData] = useState('')
//     const { toPDF, targetRef } = usePDF({ filename: 'page.pdf' });
//     const [CSVDATA, SetCSVDATA] = useState([])
//     const [summary, setSummary] = useState({ file: "", count: 0, amount: 0 });

//     const [currentPage, setCurrentPage] = useState(1);
//     const itemsPerPage = 5;
//     const totalPages = Math.ceil(ecsdata.length / itemsPerPage);

//     const reversedData = [...ecsdata].reverse();
//     const paginatedData = reversedData.slice(
//         (currentPage - 1) * itemsPerPage,
//         currentPage * itemsPerPage
//     );

//     const handlePageChange = (pageNumber) => {
//         if (pageNumber >= 1 && pageNumber <= totalPages) {
//             setCurrentPage(pageNumber);
//         }
//     };

//     useEffect(() => {
//         GetAuctions()
//     }, [])

//     async function GetAuctions() {
//         try {
//             let data = await FetchECSFiles()
//             console.log(data);
//             SetFileName(data)
//         } catch (error) {
//             console.log(error);
//         }
//     }

//     async function GetAllDashboardReport() {
//         try {
//             const data = await FetchECSDashboardReport();
//             if (data && data.length > 0) {
//                 const totalGeneratedCount = data.length;
//                 const totalGeneratedAmount = data.reduce(
//                     (sum, d) => sum + Number(d.refund_amount || 0),
//                     0
//                 );

//                 const awaitedData = data.filter((d) => d.status === "Pending");
//                 const completedData = data.filter(
//                     (d) => d.status === "Successful/Paid"
//                 );
//                 const returnData = data.filter(
//                     (d) => d.status === "Return"
//                 );
//                 const failedData = data.filter(
//                     (d) => d.status !== "Pending" && d.status !== "Successful/Paid" && d.status !== "Return"
//                 );

//                 SetECSDashboardData({
//                     totalGenerated: {
//                         count: totalGeneratedCount,
//                         amount: totalGeneratedAmount,
//                     },
//                     awaited: {
//                         count: awaitedData.length,
//                         amount: awaitedData.reduce(
//                             (sum, d) => sum + Number(d.refund_amount || 0),
//                             0
//                         ),
//                     },
//                     completed: {
//                         count: completedData.length,
//                         amount: completedData.reduce(
//                             (sum, d) => sum + Number(d.refund_amount || 0),
//                             0
//                         ),
//                     },
//                     return: {
//                         count: returnData.length,
//                         amount: returnData.reduce(
//                             (sum, d) => sum + Number(d.refund_amount || 0),
//                             0
//                         ),
//                     },
//                     failed: {
//                         count: failedData.length,
//                         amount: failedData.reduce(
//                             (sum, d) => sum + Number(d.refund_amount || 0),
//                             0
//                         ),
//                     },
//                 });
//             }
//         } catch (err) {
//             console.error("Dashboard fetch error", err);
//         }
//     }

//     // Prepare chart data
//     const chartData = [
//         { name: "Generated", Count: ecsdashboarddata.totalGenerated.count },
//         { name: "Awaited", Count: ecsdashboarddata.awaited.count },
//         { name: "Completed", Count: ecsdashboarddata.completed.count },
//         { name: "Return", Count: ecsdashboarddata.return.count },
//         { name: "Failed", Count: ecsdashboarddata.failed.count },
//     ];

//     useEffect(() => {
//         GetAllDashboardReport()
//     }, [])

//     async function GetECSReport() {
//         try {
//             if (!searchFileData) {
//                 alert("Please Select File Name")
//             } else {
//                 let data = await FetchECSReport(searchFileData)
//                 console.log("data", data);
//                 SetECSData(data)

//                 if (data && data.length > 0) {
//                     const totalAmount = data.reduce((sum, item) => sum + Number(item.refund_amount || 0), 0);
//                     setSummary({
//                         file: searchFileData,
//                         count: data.length,
//                         amount: totalAmount
//                     });
//                 } else {
//                     setSummary({ file: searchFileData, count: 0, amount: 0 });
//                 }
//             }
//         } catch (error) {
//             console.log(error);
//         }
//     }

//     function onSavefile() {
//         if (ecsdata.length > 0) {
//             const headers = Object.keys(ecsdata[0]);
//             const csvData = ecsdata.map(item => headers.map(key => item[key]));
//             const finalcsv = [headers, ...csvData];
//             SetCSVDATA(finalcsv);
//         }
//     }

//     // return (
//     //     <>
//     //         <div
//     //             style={{
//     //                 backgroundColor: "#f4f8fc",
//     //                 maxHeight: "90vh",
//     //                 overflowY: "auto",
//     //                 msOverflowStyle: "none",       // IE & Edge
//     //                 scrollbarWidth: "none",
//     //                 padding: '20px',        // Firefox
//     //             }}
//     //             className="no-scrollbar"
//     //         >
//     //             <div className="dashboard-header-name">
//     //                 <img
//     //                     src={iconSrc}
//     //                     alt={"Dashboard Icon"}
//     //                     className="dashboard-menu-icon"
//     //                 />
//     //                 <h1 className="dashboard-title">ECS Dashboard</h1>
//     //             </div>

//     //             <div style={{ padding: "20px", backgroundColor: "#f5f9fc" }}>
//     //                 <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "20px" }} >
//     //                     {/* Total Generated */}
//     //                     <div style={{ background: "linear-gradient(to right, #3d8696, #2370a0)", color: "white", padding: "20px", borderRadius: "12px", boxShadow: "0 4px 10px rgba(0,0,0,0.1)" }} >
//     //                         <h4>Total ECS Generated</h4>
//     //                         <p style={{ fontSize: "24px", fontWeight: "600" }}> {ecsdashboarddata.totalGenerated.count}</p>
//     //                         <p>₹ {ecsdashboarddata.totalGenerated.amount}</p>
//     //                     </div>
//     //                     {/* Awaited */}
//     //                     <div style={{ background: "linear-gradient(to right, #f7b733, #fc4a1a)", color: "white", padding: "20px", borderRadius: "12px", boxShadow: "0 4px 10px rgba(0,0,0,0.1)" }}>
//     //                         <h4>ECS Awaited</h4>
//     //                         <p style={{ fontSize: "24px", fontWeight: "600" }}>{ecsdashboarddata.awaited.count}</p>
//     //                         <p>₹ {ecsdashboarddata.awaited.amount}</p>
//     //                     </div>
//     //                     {/* Completed */}
//     //                     <div style={{ background: "linear-gradient(to right, #11998e, #38ef7d)", color: "white", padding: "20px", borderRadius: "12px", boxShadow: "0 4px 10px rgba(0,0,0,0.1)" }}>
//     //                         <h4>ECS Completed</h4>
//     //                         <p style={{ fontSize: "24px", fontWeight: "600" }}> {ecsdashboarddata.completed.count}</p>
//     //                         <p>₹ {ecsdashboarddata.completed.amount}</p>
//     //                     </div>
//     //                     {/* Return */}
//     //                     <div style={{ background: "linear-gradient(to right, #8185ffff, #31009cff)", color: "white", padding: "20px", borderRadius: "12px", boxShadow: "0 4px 10px rgba(0,0,0,0.1)" }}>
//     //                         <h4>ECS Return</h4>
//     //                         <p style={{ fontSize: "24px", fontWeight: "600" }}> {ecsdashboarddata.return.count}</p>
//     //                         <p>₹ {ecsdashboarddata.return.amount}</p>
//     //                     </div>
//     //                     {/* Failed */}
//     //                     <div style={{ background: "linear-gradient(to right, #e52d27, #b31217)", color: "white", padding: "20px", borderRadius: "12px", boxShadow: "0 4px 10px rgba(0,0,0,0.1)" }}>
//     //                         <h4>ECS Failed</h4>
//     //                         <p style={{ fontSize: "24px", fontWeight: "600" }}> {ecsdashboarddata.failed.count}</p>
//     //                         <p>₹ {ecsdashboarddata.failed.amount}</p>
//     //                     </div>
//     //                 </div>
//     //             </div>

//     //             {/* Chart */}
//     //             <div style={{ width: "100%", height: 400, backgroundColor: "white", padding: "20px", borderRadius: "12px", boxShadow: "0 4px 10px rgba(0,0,0,0.1)" }}>
//     //                 <h3 style={{ textAlign: "center", marginBottom: "20px" }}>ECS Status Count</h3>
//     //                 <ResponsiveContainer width="100%" height="100%">
//     //                     <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
//     //                         <CartesianGrid strokeDasharray="3 3" />
//     //                         <XAxis dataKey="name" />
//     //                         <YAxis />
//     //                         <Tooltip />
//     //                         <Legend />
//     //                         <Bar dataKey="Count" fill="#8884d8" />
//     //                     </BarChart>
//     //                 </ResponsiveContainer>
//     //             </div>
//     //             <div style={{ padding: '2rem' }}>
//     //                 <div style={{ display: "grid", border: "2px solid red", borderRadius: "10px", border: "none", padding: "20px", backgroundColor: 'white' }}>
//     //                     <div style={{ display: 'grid' }}>
//     //                         <Form>
//     //                             <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: '20px', alignItems: 'center' }}>
//     //                                 <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
//     //                                     <label className='form-label mx-3' style={{ fontWeight: '600', display: 'flex' }}>File Name</label>
//     //                                     <select className='form-control' onChange={(e) => { SetSearchFileData(e.currentTarget.value) }} style={{ width: "25rem", fontWeight: '600' }}>
//     //                                         <option selected disabled>Select File</option>
//     //                                         {
//     //                                             fileName && fileName?.map((e, index) => {
//     //                                                 return (
//     //                                                     <>
//     //                                                         <option value={e.FileName}>{e.FileName}</option>
//     //                                                     </>
//     //                                                 )
//     //                                             })
//     //                                         }
//     //                                     </select>
//     //                                 </div>
//     //                                 <div>
//     //                                     <button className="pending-button" type="button" onClick={() => GetECSReport()} style={{ display: 'flex', alignItems: 'center', border: '2px solid #0071bc', borderRadius: '5px', width: '6rem', height: '2.3rem', fontSize: '14px', color: '#0071bc', backgroundColor: 'white', cursor: 'pointer' }}><img src='' className="mx-1" alt="pending" /> Search</button>
//     //                                 </div>

//     //                             </div>
//     //                         </Form>
//     //                     </div>
//     //                 </div>
//     //             </div>

//     //             <div style={{ padding: "20px", overflow: "auto", backgroundColor: '#f5f9fc' }}>
//     //                 <div style={{ display: "grid", borderRadius: "20px", padding: "20px", backgroundColor: 'white' }}>
//     //                     <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//     //                         <div style={{ display: "flex", alignItems: "center", gap: '10px' }}>
//     //                             <h5 style={{ paddingTop: '10px' }}>Payment Data</h5>
//     //                         </div>
//     //                         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px', paddingBottom: '10px' }}>
//     //                             {
//     //                                 ecsdata.length > 0 ? (
//     //                                     <>
//     //                                         <button onClick={toPDF} type='button' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '8rem', height: '2rem', border: '2px solid darkgray', backgroundColor: '#f2f2f2', borderRadius: '20px', gap: '3px', color: 'black', cursor: 'pointer' }} ><img src='' style={{ width: '14px' }} /> Download PDF</button>
//     //                                         <CSVLink data={CSVDATA} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '8rem', height: '2rem', border: '2px solid darkgray', backgroundColor: '#f2f2f2', borderRadius: '20px', gap: '3px', color: 'black', textDecoration: 'none', fontSize: '12px', fontWeight: '500', cursor: 'pointer' }} onClick={onSavefile}><img src='' style={{ width: '14px' }} /> Download Excel</CSVLink>
//     //                                     </>
//     //                                 ) : (
//     //                                     <>
//     //                                         <div type='button' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '8rem', height: '2rem', border: '2px solid darkgray', backgroundColor: '#f2f2f2', borderRadius: '20px', gap: '3px', color: 'black', fontSize: '14px', cursor: 'pointer' }} disabled><img src='' style={{ width: '14px' }} /> Download PDF</div>
//     //                                         <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '8rem', height: '2rem', border: '2px solid darkgray', backgroundColor: '#f2f2f2', borderRadius: '20px', gap: '3px', color: 'black', fontSize: '14px', cursor: 'pointer' }} disabled><img src='' style={{ width: '14px' }} /> Download Excel
//     //                                         </div>
//     //                                     </>
//     //                                 )
//     //                             }
//     //                         </div>
//     //                     </div>
//     //                     <div style={{ width: '100%', border: "1px solid green" }}>
//     //                         <table style={{ backgroundColor: '#e8f7f3', width: '100%', borderCollapse: "collapse" }} ref={targetRef}>
//     //                             <thead>
//     //                                 {/* Summary Header */}
//     //                                 <tr style={{ background: 'linear-gradient(to Right, #3d8696, #2370a0, #4163a4, #575aa7, #754baa)', color: 'white' }}>
//     //                                     <th>File Name</th>
//     //                                     <th>Total Count</th>
//     //                                     <th>Total Amount</th>
//     //                                 </tr>
//     //                                 {summary.file && (
//     //                                     <tr style={{ backgroundColor: "#c8e5fc", fontWeight: "600" }}>
//     //                                         <td><a href={`${apiurl}/UploadedBillsFiles/${summary.file}`} target='_blank'>{summary.file}</a></td>
//     //                                         {/* <td>{summary.file}</td> */}
//     //                                         <td>{summary.count}</td>
//     //                                         <td>{summary.amount}</td>
//     //                                     </tr>
//     //                                 )}

//     //                                 {/* Detail Table Header */}
//     //                                 <tr style={{ background: 'linear-gradient(to Right, #3d8696, #2370a0, #4163a4, #575aa7, #754baa)', color: 'white' }}>
//     //                                     <th>Sr.No.</th>
//     //                                     <th>Unique_ID</th>
//     //                                     <th>Account_HolderName</th>
//     //                                     <th>AccNumber</th>
//     //                                     <th>IFSC_CODE</th>
//     //                                     <th>refund_amount</th>
//     //                                     <th>Payment_Mode</th>
//     //                                     <th>status</th>
//     //                                     <th>statusDesc</th>
//     //                                     <th>Date</th>
//     //                                 </tr>
//     //                             </thead>

//     //                             <tbody>
//     //                                 {paginatedData && paginatedData.length > 0 ? (
//     //                                     paginatedData.map((e, index) => (
//     //                                         <tr key={index}>
//     //                                             <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
//     //                                             <td>{e.Unique_ID}</td>
//     //                                             <td>{e.Account_HolderName}</td>
//     //                                             <td>{e.AccNumber}</td>
//     //                                             <td>{e.IFSC_CODE}</td>
//     //                                             <td>{e.refund_amount}</td>
//     //                                             <td>{e.Payment_Mode}</td>
//     //                                             <td>{e.status}</td>
//     //                                             <td>{e.statusDesc}</td>
//     //                                             <td>{e.Date?.split('.')[0].replace('T', ' ')}</td>
//     //                                         </tr>
//     //                                     ))
//     //                                 ) : (
//     //                                     <tr>
//     //                                         <td colSpan="10" style={{ textAlign: 'center' }}>No data available in table</td>
//     //                                     </tr>
//     //                                 )}
//     //                             </tbody>
//     //                         </table>
//     //                         <div style={{ display: 'flex', justifyContent: 'space-between', backgroundColor: '#c8e5fc', padding: ' 0px 10px 0px 10px', height: '3rem', alignItems: 'center' }}>
//     //                             <div><p style={{ margin: '0px' }}>Showing {paginatedData.length} of {ecsdata.length} entries</p></div>
//     //                             <div >
//     //                                 {/* First Page Button */}
//     //                                 <button onClick={() => handlePageChange(1)} disabled={currentPage === 1} style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0 }}> &laquo; </button>
//     //                                 {/* Previous Button */}
//     //                                 <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}> &lt; </button>
//     //                                 {/* Page Buttons */}
//     //                                 {Array.from({ length: totalPages }, (_, index) => (
//     //                                     <button key={index} onClick={() => handlePageChange(index + 1)} style={{ background: 'linear-gradient(to Right, #20ae8a, #3d8696, #2370a0, #4163a4, #575aa7, #754baa)', color: currentPage === index + 1 ? 'white' : 'black', cursor: 'pointer', fontSize: '24px', width: '3rem', margin: 0, borderRadius: 0, border: '1px solid lightgrey', borderLeft: "none" }}>{index + 1}</button>
//     //                                 ))}
//     //                                 {/* Next Button */}
//     //                                 <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}> &gt; </button>
//     //                                 {/* Last Page Button */}
//     //                                 <button onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}> &raquo;</button>
//     //                             </div>
//     //                         </div>
//     //                     </div>
//     //                 </div>
//     //             </div>
//     //         </div>
//     //     </>
//     // )
//       return (
//         <>
//             <div
//                 style={{
//                     backgroundColor: "#f4f8fc",
//                     maxHeight: "90vh",
//                     overflowY: "auto",
//                     msOverflowStyle: "none",       // IE & Edge
//                     scrollbarWidth: "none",
//                     padding: '20px',        // Firefox
//                 }}
//                 className="no-scrollbar"
//             >
//                 <div className="dashboard-header-name">
//                     <img
//                         src={iconSrc}
//                         alt={"Dashboard Icon"}
//                         className="dashboard-menu-icon"
//                     />
//                     <h1 className="dashboard-title">{t("ECS Dashboard")}</h1>
//                 </div>

//                 <div style={{ padding: "20px", backgroundColor: "#f5f9fc" }}>
//                     <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "20px" }} >
//                         {/* Total Generated */}
//                         <div style={{ background: "linear-gradient(to right, #3d8696, #2370a0)", color: "white", padding: "20px", borderRadius: "12px", boxShadow: "0 4px 10px rgba(0,0,0,0.1)" }} >
//                             <h4>{t("Total ECS Generated")}</h4>
//                             <p style={{ fontSize: "24px", fontWeight: "600" }}> {ecsdashboarddata.totalGenerated.count}</p>
//                             <p>₹ {ecsdashboarddata.totalGenerated.amount}</p>
//                         </div>
//                         {/* Awaited */}
//                         <div style={{ background: "linear-gradient(to right, #f7b733, #fc4a1a)", color: "white", padding: "20px", borderRadius: "12px", boxShadow: "0 4px 10px rgba(0,0,0,0.1)" }}>
//                             <h4>{t("ECS Awaited")}</h4>
//                             <p style={{ fontSize: "24px", fontWeight: "600" }}>{ecsdashboarddata.awaited.count}</p>
//                             <p>₹ {ecsdashboarddata.awaited.amount}</p>
//                         </div>
//                         {/* Completed */}
//                         <div style={{ background: "linear-gradient(to right, #11998e, #38ef7d)", color: "white", padding: "20px", borderRadius: "12px", boxShadow: "0 4px 10px rgba(0,0,0,0.1)" }}>
//                             <h4>{t("ECS Completed")}</h4>
//                             <p style={{ fontSize: "24px", fontWeight: "600" }}> {ecsdashboarddata.completed.count}</p>
//                             <p>₹ {ecsdashboarddata.completed.amount}</p>
//                         </div>
//                         {/* Return */}
//                         <div style={{ background: "linear-gradient(to right, #8185ffff, #31009cff)", color: "white", padding: "20px", borderRadius: "12px", boxShadow: "0 4px 10px rgba(0,0,0,0.1)" }}>
//                             <h4>{t("ECS Return")}</h4>
//                             <p style={{ fontSize: "24px", fontWeight: "600" }}> {ecsdashboarddata.return.count}</p>
//                             <p>₹ {ecsdashboarddata.return.amount}</p>
//                         </div>
//                         {/* Failed */}
//                         <div style={{ background: "linear-gradient(to right, #e52d27, #b31217)", color: "white", padding: "20px", borderRadius: "12px", boxShadow: "0 4px 10px rgba(0,0,0,0.1)" }}>
//                             <h4>{t("ECS Failed")}</h4>
//                             <p style={{ fontSize: "24px", fontWeight: "600" }}> {ecsdashboarddata.failed.count}</p>
//                             <p>₹ {ecsdashboarddata.failed.amount}</p>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Chart */}
//                 <div style={{ width: "100%", height: 400, backgroundColor: "white", padding: "20px", borderRadius: "12px", boxShadow: "0 4px 10px rgba(0,0,0,0.1)" }}>
//                     <h3 style={{ textAlign: "center", marginBottom: "20px" }}>{t("ECS Status Count")}</h3>
//                     <ResponsiveContainer width="100%" height="100%">
//                         <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
//                             <CartesianGrid strokeDasharray="3 3" />
//                             <XAxis dataKey="name" />
//                             <YAxis />
//                             <Tooltip />
//                             <Legend />
//                             <Bar dataKey="Count" fill="#8884d8" />
//                         </BarChart>
//                     </ResponsiveContainer>
//                 </div>

//                 {/* <div style={{ display: "flex", justifyContent: "end" }} className='my-3'>
//                     <div className='mx-3'>
//                         <button className="pending-button" type="button" onClick={() => {
//                             if (window.confirm("Are you sure you want to download the Response File?")) {
//                                 GetAllFiles("REV");
//                             }
//                         }} style={{ display: 'flex', alignItems: 'center', border: '2px solid #0071bc', borderRadius: '5px', width: '10rem', height: '3rem', fontSize: '14px', color: 'white', backgroundColor: '#0071bc', cursor: 'pointer' }} > {t("Get Response File")}</button>
//                     </div>
//                     <div className='mx-3'>
//                         <button className="pending-button" type="button" onClick={() => {
//                             if (window.confirm("Are you sure you want to download the Error File?")) {
//                                 GetAllFiles("ERROR");
//                             }
//                         }} style={{ display: 'flex', alignItems: 'center', border: '2px solid #0071bc', borderRadius: '5px', width: '10rem', height: '3rem', fontSize: '14px', color: 'white', backgroundColor: '#0071bc', cursor: 'pointer' }} > {t("Get Error File")}</button>
//                     </div>
//                     <div className='mx-3'>
//                         <button className="pending-button" type="button" onClick={() => {
//                             if (window.confirm("Are you sure you want to download the Return File?")) {
//                                 GetAllFiles("RET");
//                             }
//                         }} style={{ display: 'flex', alignItems: 'center', border: '2px solid #0071bc', borderRadius: '5px', width: '10rem', height: '3rem', fontSize: '14px', color: 'white', backgroundColor: '#0071bc', cursor: 'pointer' }}>{t("Get Return File")}</button>
//                     </div>
//                 </div> */}
//                 <div style={{ padding: '2rem' }}>
//                     <div style={{ display: "grid", border: "2px solid red", borderRadius: "10px", border: "none", padding: "20px", backgroundColor: 'white' }}>
//                         <div style={{ display: 'grid' }}>
//                             <Form>
//                                 <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: '20px', alignItems: 'center' }}>
//                                     <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
//                                         <label className='form-label mx-3' style={{ fontWeight: '600', display: 'flex' }}>{t("File Name")}</label>
//                                         <select className='form-control' onChange={(e) => { SetSearchFileData(e.currentTarget.value) }} style={{ width: "25rem", fontWeight: '600' }}>
//                                             <option selected disabled>{t("Select File")}</option>
//                                             {
//                                                 fileName && fileName?.map((e, index) => {
//                                                     return (
//                                                         <>
//                                                             <option value={e.FileName}>{e.FileName}</option>
//                                                         </>
//                                                     )
//                                                 })
//                                             }
//                                         </select>
//                                     </div>
//                                     <div>
//                                         <button className="pending-button" type="button" onClick={() => GetECSReport()} style={{ display: 'flex', alignItems: 'center', border: '2px solid #0071bc', borderRadius: '5px', width: '6rem', height: '2.3rem', fontSize: '14px', color: '#0071bc', backgroundColor: 'white', cursor: 'pointer' }}>
//                                             <FaSearch size={14} />
//                                              {t("Search")}</button>
//                                     </div>

//                                 </div>
//                             </Form>
//                         </div>
//                     </div>
//                 </div>

//                 <div style={{ padding: "20px", overflow: "auto", backgroundColor: '#f5f9fc' }}>
//                     <div style={{ display: "grid", borderRadius: "20px", padding: "20px", backgroundColor: 'white' }}>
//                         <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//                             <div style={{ display: "flex", alignItems: "center", gap: '10px' }}>
//                                 <h5 style={{ paddingTop: '10px' }}>{t("Payment Data")}</h5>
//                             </div>
//                             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px', paddingBottom: '10px' }}>
//                                 {
//                                     ecsdata.length > 0 ? (
//                                         <>
//                                             <button onClick={toPDF} type='button' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '8rem', height: '2rem', border: '2px solid darkgray', backgroundColor: '#f2f2f2', borderRadius: '20px', gap: '3px', color: 'black', cursor: 'pointer' }} ><img src='' style={{ width: '14px' }} />{t("Download PDF")}</button>
//                                             <CSVLink data={CSVDATA} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '8rem', height: '2rem', border: '2px solid darkgray', backgroundColor: '#f2f2f2', borderRadius: '20px', gap: '3px', color: 'black', textDecoration: 'none', fontSize: '12px', fontWeight: '500', cursor: 'pointer' }} onClick={onSavefile}><img src='' style={{ width: '14px' }} /> {t("Download Excel")}</CSVLink>
//                                         </>
//                                     ) : (
//                                         <>
//                                             <div type='button' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '8rem', height: '2rem', border: '2px solid darkgray', backgroundColor: '#f2f2f2', borderRadius: '20px', gap: '3px', color: 'black', fontSize: '14px', cursor: 'pointer' }} disabled><img src='' style={{ width: '14px' }} /> {t("Download PDF")}</div>
//                                             <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '8rem', height: '2rem', border: '2px solid darkgray', backgroundColor: '#f2f2f2', borderRadius: '20px', gap: '3px', color: 'black', fontSize: '14px', cursor: 'pointer' }} disabled><img src='' style={{ width: '14px' }} /> {t("Download Excel")}
//                                             </div>
//                                         </>
//                                     )
//                                 }
//                             </div>
//                         </div>
//                         <div style={{ width: '100%', border: "1px solid green" }}>
//                             <table style={{ backgroundColor: '#e8f7f3', width: '100%', borderCollapse: "collapse" }} ref={targetRef}>
//                                 <thead>
//                                     {/* Summary Header */}
//                                     <tr style={{ background: 'linear-gradient(to Right, #3d8696, #2370a0, #4163a4, #575aa7, #754baa)', color: 'white' }}>
//                                         <th>{t("File Name")}</th>
//                                         <th>{t("Total Count")}</th>
//                                         <th>{t("Total Amount")}</th>
//                                     </tr>
//                                     {summary.file && (
//                                         <tr style={{ backgroundColor: "#c8e5fc", fontWeight: "600" }}>
//                                             <td>{summary.file}</td>
//                                             {/* <td><a href={`${apiurl}/UploadedBillsFiles/${summary.file}`} target='_blank'>{summary.file}</a></td> */}
//                                             {/* <td>{summary.file}</td> */}
//                                             <td>{summary.count}</td>
//                                             <td>{summary.amount}</td>
//                                         </tr>
//                                     )}

//                                     {/* Detail Table Header */}
//                                     <tr style={{ background: 'linear-gradient(to Right, #3d8696, #2370a0, #4163a4, #575aa7, #754baa)', color: 'white' }}>
//                                         <th>{t("Sr.No.")}</th>
//                                         <th>{t("Unique_ID")}</th>
//                                         <th>{t("Account_HolderName")}</th>
//                                         <th>{t("AccNumber")}</th>
//                                         <th>{t("IFSC_CODE")}</th>
//                                         <th>{t("refund_amount")}</th>
//                                         <th>{t("Payment_Mode")}</th>
//                                         <th>{t("status")}</th>
//                                         <th>{t("statusDesc")}</th>
//                                         <th>{t("Date")}</th>
//                                     </tr>
//                                 </thead>

//                                 <tbody>
//                                     {paginatedData && paginatedData.length > 0 ? (
//                                         paginatedData.map((e, index) => (
//                                             <tr key={index}>
//                                                 <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
//                                                 <td>{e.Unique_ID}</td>
//                                                 <td>{e.Account_HolderName}</td>
//                                                 <td>{e.AccNumber}</td>
//                                                 <td>{e.IFSC_CODE}</td>
//                                                 <td>{e.refund_amount}</td>
//                                                 <td>{e.Payment_Mode}</td>
//                                                 <td>{e.status}</td>
//                                                 <td>{e.statusDesc}</td>
//                                                 <td>{e.Date?.split('.')[0].replace('T', ' ')}</td>
//                                             </tr>
//                                         ))
//                                     ) : (
//                                         <tr>
//                                             <td colSpan="10" style={{ textAlign: 'center' }}>{t("No data available in table")}</td>
//                                         </tr>
//                                     )}
//                                 </tbody>
//                             </table>
//                             <div style={{ display: 'flex', justifyContent: 'space-between', backgroundColor: '#c8e5fc', padding: ' 0px 10px 0px 10px', height: '3rem', alignItems: 'center' }}>
//                                 <div><p style={{ margin: '0px' }}>{t("Showing")} {paginatedData.length} {t("of")} {ecsdata.length} {t("entries")}</p></div>
//                                 <div >
//                                     {/* First Page Button */}
//                                     <button onClick={() => handlePageChange(1)} disabled={currentPage === 1} style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0 }}> &laquo; </button>
//                                     {/* Previous Button */}
//                                     <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}> &lt; </button>
//                                     {/* Page Buttons */}
//                                     {Array.from({ length: totalPages }, (_, index) => (
//                                         <button key={index} onClick={() => handlePageChange(index + 1)} style={{ background: 'linear-gradient(to Right, #20ae8a, #3d8696, #2370a0, #4163a4, #575aa7, #754baa)', color: currentPage === index + 1 ? 'white' : 'black', cursor: 'pointer', fontSize: '24px', width: '3rem', margin: 0, borderRadius: 0, border: '1px solid lightgrey', borderLeft: "none" }}>{index + 1}</button>
//                                     ))}
//                                     {/* Next Button */}
//                                     <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}> &gt; </button>
//                                     {/* Last Page Button */}
//                                     <button onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}> &raquo;</button>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     )
// }

// export default ECSReport;
